import React, { useState } from 'react';
import db from '../lib/instant';

const InvitationNotifications = () => {
  const user = db.useUser();
  const [processedInvites, setProcessedInvites] = useState(new Set());

  // Query invitations for the current user's email
  const { data } = db.useQuery(user ? {
    invitations: {},
    projects: {},
    users: {}
  } : {});

  // Find pending invitations for this user's email
  const pendingInvitations = data?.invitations?.filter(
    inv => inv.invited_email === user?.email && 
           inv.status === 'pending' && 
           !processedInvites.has(inv.id) &&
           new Date(inv.expires_at) > new Date() // Not expired
  ) || [];

  const handleAcceptInvitation = async (invitation) => {
    try {
      const membershipId = crypto.randomUUID();
      
      await db.transact([
        // Add user to project
        db.tx.project_members[membershipId].update({
          project_id: invitation.project_id,
          user_id: user.id,
          role: invitation.role,
          joined_at: new Date().toISOString()
        }),
        // Update invitation status
        db.tx.invitations[invitation.id].update({
          ...invitation,
          status: 'accepted'
        })
      ]);
      
      // Mark as processed locally
      setProcessedInvites(prev => new Set(prev).add(invitation.id));
    } catch (error) {
      console.error('Error accepting invitation:', error);
    }
  };

  const handleDeclineInvitation = async (invitation) => {
    try {
      await db.transact([
        db.tx.invitations[invitation.id].update({
          ...invitation,
          status: 'declined'
        })
      ]);
      
      // Mark as processed locally
      setProcessedInvites(prev => new Set(prev).add(invitation.id));
    } catch (error) {
      console.error('Error declining invitation:', error);
    }
  };

  if (pendingInvitations.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      {pendingInvitations.map(invitation => {
        const project = data?.projects?.find(p => p.id === invitation.project_id);
        const inviterUser = data?.users?.find(u => u.id === invitation.invited_by);
        
        return (
          <div key={invitation.id} className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-3">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center">
                  <svg className="w-6 h-6 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
                  </svg>
                  <h3 className="text-lg font-medium text-blue-900">Project Invitation</h3>
                </div>
                <p className="text-blue-800 mt-1">
                  <strong>{inviterUser?.name || inviterUser?.email || 'Someone'}</strong> invited you to join the project{' '}
                  <strong>"{project?.name || 'Unknown Project'}"</strong> as a <strong>{invitation.role}</strong>.
                </p>
                <p className="text-blue-600 text-sm mt-1">
                  Expires on {new Date(invitation.expires_at).toLocaleDateString()}
                </p>
              </div>
              
              <div className="flex space-x-2 ml-4">
                <button
                  onClick={() => handleAcceptInvitation(invitation)}
                  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md text-sm font-medium"
                >
                  Accept
                </button>
                <button
                  onClick={() => handleDeclineInvitation(invitation)}
                  className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md text-sm font-medium"
                >
                  Decline
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default InvitationNotifications;